// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MangoHubGetPatientSummaryPrescription {
    'drugName': string;
    'strength': string;
    'usageForm': string;
    'dosage': string;
    'daySupply': number | null;
    'quantity': number | null;
    'prescribedDate': Moment | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MangoHubGetPatientSummaryPrescription>> = [
        {
            "name":     "drugName",
            "baseName": "drugName",
            "type":     "string"
        },
        {
            "name":     "strength",
            "baseName": "strength",
            "type":     "string"
        },
        {
            "name":     "usageForm",
            "baseName": "usageForm",
            "type":     "string"
        },
        {
            "name":     "dosage",
            "baseName": "dosage",
            "type":     "string"
        },
        {
            "name":     "daySupply",
            "baseName": "daySupply",
            "type":     "number"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "number"
        },
        {
            "name":     "prescribedDate",
            "baseName": "prescribedDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return MangoHubGetPatientSummaryPrescription.attributeTypeMap;
    }
}
